/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AltaEfectoSecundarioProgramaPacienteDto } from '../../models/alta-efecto-secundario-programa-paciente-dto';

export interface FarmacosControllerRegistrarEfectoSecundarioPaciente$Params {
  programaUuid: string;
  efectoSecundarioUuid: string;
      body: AltaEfectoSecundarioProgramaPacienteDto
}

export function farmacosControllerRegistrarEfectoSecundarioPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerRegistrarEfectoSecundarioPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerRegistrarEfectoSecundarioPaciente.PATH, 'post');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
    rb.path('efectoSecundarioUuid', params.efectoSecundarioUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

farmacosControllerRegistrarEfectoSecundarioPaciente.PATH = '/api/farmacos/efecto-secundario/{programaUuid}/{efectoSecundarioUuid}';
